import { render, staticRenderFns } from "./orgdashboard.vue?vue&type=template&id=815e8e24&scoped=true&"
import script from "./orgdashboard.vue?vue&type=script&lang=js&"
export * from "./orgdashboard.vue?vue&type=script&lang=js&"
import style0 from "./orgdashboard.vue?vue&type=style&index=0&id=815e8e24&prod&scoped=true&lang=css&"
import style1 from "./orgdashboard.vue?vue&type=style&index=1&id=815e8e24&prod&lang=css&"
import style2 from "./orgdashboard.vue?vue&type=style&index=2&id=815e8e24&prod&lang=css&"
import style3 from "./orgdashboard.vue?vue&type=style&index=3&id=815e8e24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815e8e24",
  null
  
)

export default component.exports